/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_type_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is a typed signature legally binding?`)
};

const es_sig_type_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es una firma escrita legalmente vinculante?`)
};

const de_sig_type_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist eine getippte Signatur rechtlich bindend?`)
};

const nl_sig_type_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is een getypte handtekening juridisch bindend?`)
};

const fr_sig_type_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une signature dactylographiée est-elle juridiquement contraignante?`)
};

const it_sig_type_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una firma dattilografata è legalmente vincolante?`)
};

const pt_br2_sig_type_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma assinatura digitada é vinculante legalmente?`)
};

const pt_sig_type_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma assinatura digitada é legalmente vinculativa?`)
};

const ja_sig_type_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入力された署名は法的に拘束力がありますか?`)
};

const zh_sig_type_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入的签名在法律上具有约束力吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_type_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_type_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_type_faq4_q", locale)
	if (locale === "en") return en_sig_type_faq4_q(inputs)
	if (locale === "es") return es_sig_type_faq4_q(inputs)
	if (locale === "de") return de_sig_type_faq4_q(inputs)
	if (locale === "nl") return nl_sig_type_faq4_q(inputs)
	if (locale === "fr") return fr_sig_type_faq4_q(inputs)
	if (locale === "it") return it_sig_type_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_sig_type_faq4_q(inputs)
	if (locale === "pt") return pt_sig_type_faq4_q(inputs)
	if (locale === "ja") return ja_sig_type_faq4_q(inputs)
	return zh_sig_type_faq4_q(inputs)
};